import React from "react";

const PricingArrowDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    fill="none"
    viewBox="0 0 200 200"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100Zm4.625-159a5 5 0 0 0-10 0v106.801l-50.063-50.81a5 5 0 0 0-7.124 7.018l58.625 59.5a5 5 0 0 0 7.124 0l58.625-59.5a5 5 0 0 0-7.124-7.018l-50.063 50.81V41Z"
      clipRule="evenodd"
    />
  </svg>
);

export default PricingArrowDown;


// WEBPACK FOOTER //
// ./resources/assets/js/app/Icons/PricingArrowDown.icon.js